import { useState, useEffect } from 'react';
import { useChat } from '../contexts/ChatContext';
import { sendMessage } from '../services/apiClient';
import { v4 as uuidv4 } from 'uuid';
import { getUserSessions, getSessionMessages, getCurrentUser, getFullHistory } from "../services/apiClient";
import { ASSISTANTS  } from "../config/assistants"; 
import { MODELS }from '../config/models';
//import { getCurrentUser } from "../services/auth";


function ChatWindow() {
    const { currentAssistant, selectedModel, chats, setChats } = useChat();
    const [ input, setInput ] = useState("");
    const [ isTyping, setIsTyping ] = useState(false);
    const [showHistory, setShowHistory] = useState(true); 

    const [sessionId, setSessionId] = useState(uuidv4());
    const [createSession, setCreateSession] = useState(true);

    const [sessions, setSessions] = useState([]);
    const [historyLoaded, setHistoryLoaded] = useState(false);


    const messages = chats[currentAssistant] || [];

    //const modelId = MODELS[selectedModel].modelId;


    useEffect(() => {
        if (!historyLoaded && currentAssistant) {
          const userId = getCurrentUser();
          getUserSessions(userId, currentAssistant, selectedModel)
            .then(setSessions)
            .catch(err => console.error("Failed to fetch sessions:", err))
            .finally(() => setHistoryLoaded(true));
        }
    }, [historyLoaded, currentAssistant]);


    /*
    useEffect(() => {
        const userId = getCurrentUser();
      
        if (createSession && sessionId && userId && currentAssistant) {
          const createSessionHeader = async () => {
            try {
              const params = new URLSearchParams({
                action: "send_message",
                user_id: userId,
                session_id: sessionId,
                query: "__init__",  // dummy query to create the session
                history: "[]",
                createSession: "true",
                type:'session'
              });
      
              const url = `${ASSISTANTS[currentAssistant].apiUrl}?${params.toString()}`;
              console.log("ChatWindow.js : url = ", url);
              await fetch(url, {
                method: "GET",
                headers: { "Content-Type": "application/json" }
              });
      
              console.log("[DEBUG] Initial session header created.");
              setCreateSession(false);
            } catch (err) {
              console.error("Failed to create initial session:", err);
            }
          };
      
          createSessionHeader();
        }
      }, [createSession, sessionId, currentAssistant]);
    */


    const handleSessionClick = async (clickedSessionId) => {
        const userId = getCurrentUser();
        
        try {
            const fullHistory = await getFullHistory(userId, currentAssistant, selectedModel); 
            const messagesForSession = getSessionMessages(fullHistory, clickedSessionId);

            console.log("chatWindow.js : messagesForSession : ", messagesForSession);
        
            setChats({
            ...chats,
            [currentAssistant]: messagesForSession,
            });
        
            setSessionId(clickedSessionId);
            setCreateSession(false);
        } catch (err) {
            console.error("Error loading session messages:", err);
        }
    };

    const startNewChat = () => {
        const newSessionId = uuidv4();
        setSessionId(newSessionId);
        setChats({ ...chats, [currentAssistant]: [] });
        setCreateSession(true);
    }

    const handleSend = async () => {
        if( !input.trim() ) return ;
        
        const userMessage = { role: "user", content: input, timestamp: new Date().toISOString() };
        const assistantMessages = chats[currentAssistant] || [];
        const newMessages = [ ...assistantMessages, userMessage ];
        console.log("newMessages" + newMessages);

        setChats( { ...chats, [currentAssistant]: newMessages });
        setInput("");
        setIsTyping(true);

        try {
            const response = await sendMessage(currentAssistant, newMessages, sessionId, createSession, selectedModel);
            console.log("Response")
            console.log(response.answer)
            const assistantReply = {
              role: "assistant",
              content: response.answer || "No response.",
              source: response.source || "",
              timestamp: new Date().toISOString()
            };

            console.log("Assistant Reply")
            console.log(assistantReply)
        
            const updatedMessages = [...newMessages, assistantReply];
            setChats({ ...chats, [currentAssistant]: updatedMessages });

            if (createSession) {
               setCreateSession(false);
            }

          } catch (err) {
            const errorMessage = {
              role: "assistant",
              content: "Error fetching assistant response."
            };
            setChats({ ...chats, [currentAssistant]: [...newMessages, errorMessage] });
        } finally {
            setIsTyping(false);
        }
    }


    return (
        //<div className="flex space-x-4 h-[32rem]"> {/* Outer flex row layout */}
        <div className="flex h-[32rem] space-x-4 relative">
            {/* 🟦 TOGGLE ICON */}
            <button
                onClick={() => setShowHistory(!showHistory)}
                className="absolute left-0 top-0 transform -translate-x-10 mt-2 p-2 rounded-md text-lg bg-gray-300 dark:bg-gray-700 hover:bg-gray-400 dark:hover:bg-gray-600"
                title={showHistory ? "Hide Previous Chats" : "Show Previous Chats"}
            >
                {showHistory ?  "📂" : "🗂️"}
            </button>
          
            {/* 🗂️ LEFT: Previous Sessions */}
            {showHistory && (
                <div className="w-1/4 bg-gray-100 dark:bg-gray-800 p-4 rounded-md overflow-y-auto border border-gray-300 dark:border-gray-700">
                <h2 className="text-md font-semibold mb-2 text-gray-800 dark:text-white">Previous Chats</h2>
                <div className="flex flex-col space-y-2">
                    {sessions.map((s, idx) => (
                    <button
                        key={idx}
                        onClick={() => handleSessionClick(s.session_id)}
                        className="w-full text-left px-3 py-2 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded text-sm"
                    >
                        {s.title || `Session ${idx + 1}`}
                    </button>
                    ))}
                </div>
                <button
                    onClick={startNewChat}
                    className="mt-4 w-full px-3 py-2 bg-blue-600 text-white rounded text-sm hover:bg-blue-700"
                >
                    + New Chat
                </button>
                </div>
            )}
      
          {/* RIGHT: Chat Interface */}
          <div className="flex-1 flex flex-col space-y-4">
            {/* Chat Message Area */}
            <div className="flex-1 overflow-y-auto bg-gray-50 p-4 rounded-md border border-gray-200 space-y-2 dark:bg-gray-900 dark:border-gray-700">
              {messages.map((m, i) => {
                const isUser = m.role === "user";
                const isLast = i === messages.length - 1 || messages[i + 1].role !== m.role;
      
                return (
                  <div key={i} className={`flex items-end space-x-2 ${isUser ? "justify-end" : "justify-start"}`}>
                    {!isUser && isLast && (
                      <div className="w-8 h-8 bg-gray-400 text-white flex items-center justify-center rounded-full text-xs">
                        🤖
                      </div>
                    )}
                    <div
                      className={`max-w-[75%] px-4 py-2 mb-1 rounded-lg text-sm whitespace-pre-wrap ${
                        isUser
                          ? "bg-blue-100 dark:bg-blue-700 text-right"
                          : "bg-gray-200 dark:bg-gray-600 text-left"
                      }`}
                    >
                      <p>{m.content}</p>
                      {isLast && (
                        <p className="text-xs text-gray-500 dark:text-gray-300 mt-1">
                          {new Date(m.timestamp).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </p>
                      )}
                    </div>
                    {isUser && isLast && (
                      <div className="w-8 h-8 bg-blue-500 text-white flex items-center justify-center rounded-full text-xs">
                        🧑
                      </div>
                    )}
                  </div>
                );
              })}
      
              {isTyping && (
                <div className="text-sm italic text-gray-400 dark:text-gray-300">
                  Assistant is typing...
                </div>
              )}
            </div>
      
            {/* Input Box */}
            <div className="flex space-x-2">
              <input
                type="text"
                className="flex-1 p-2 border border-gray-300 rounded-md 
                 bg-white text-black 
                 dark:bg-gray-700 dark:text-white dark:border-gray-600"
                placeholder="Type your message..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSend()}
              />
              <button
                onClick={handleSend}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                Send
              </button>
            </div>
          </div>
        </div>
      );
}


export default ChatWindow;



/*
return (
        <div>
            <div style={{ marginBottom: "1rem" }}>
                {messages.map( (m,i) => (
                    <div key={i} style={{ textAlign: m.role === "user" ? "right" : "left" }}>
                        <p><strong>{m.role}</strong>: {m.content}</p>
                    </div>    
                ))}

            </div>

            <input
                text="text"
                value={input}
                onChange={ (e) => setInput(e.target.value)}
                onKeyDown={ (e) => e.key === "Enter" && handleSend()}
                placeholder="Type your message..."
            />
            <button onClick={handleSend}>Send</button>
        </div>
    )
*/